import { generatePath } from 'react-router-dom';
import { ApiCacheTags, ApiCacheTagsArray, baseApiService } from '@qapline/api';
import { getConfig } from '@qapline/config';
import { TagDescription } from '@reduxjs/toolkit/query';

import { TChangeUserPasswordRequestBody, TUpdateUserRequestBody, TUser, userSchema } from '../types';

const { get: getEndpoint, update: updateEndpoint, password: passwordEndpoint } = getConfig().api.endpoints.user;
const { item: itemTag } = ApiCacheTags.user;

export const userApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        getUser: builder.query<TUser, number>({
            query: (userId) => ({
                url: generatePath(getEndpoint, { userId: userId.toString() }),
            }),
            providesTags: (res, error) => (error ? [] : [{ type: itemTag, id: res?.user_id }]),
            transformResponse: (data) => userSchema.parse(data),
        }),
        updateUser: builder.mutation<TUser, TUpdateUserRequestBody>({
            query: ({ userId, ...data }) => {
                return {
                    url: generatePath(updateEndpoint, { userId: userId.toString() }),
                    method: 'PUT',
                    body: data,
                };
            },
            invalidatesTags: (_res, error, { userId }) => {
                if (error) return [];
                const tags: TagDescription<(typeof ApiCacheTagsArray)[number]>[] = [];
                tags.push({ type: itemTag, id: userId });
                return tags;
            },
            transformResponse: (data) => userSchema.parse(data),
        }),
        changeUserPassword: builder.mutation<void, TChangeUserPasswordRequestBody>({
            query: ({ userId, newPassword, oldPassword }) => ({
                url: generatePath(passwordEndpoint, { userId: userId.toString() }),
                method: 'PATCH',
                body: { newPassword, oldPassword },
            }),
        }),
    }),
});

export const { useGetUserQuery, useLazyGetUserQuery, useUpdateUserMutation, useChangeUserPasswordMutation } = userApi;
